<template>
  <div id="customize">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>

    <div class="header">
      <div class="level is-mobile no-margin">
        <div class="level-left">
          <img src="@/assets/icons/wilderverse.png">
        </div>
        <div class="level-right">
          <div class="stacked">
            <img
              src="@/assets/icons/done-button.svg"
              @click="done()"
            >
            <p>DONE!</p>
          </div>
        </div>
      </div>
    </div>
    <div class="view">
      <div class="jungle-background">
        <web-gl-view
          :style="{ width: '100%', height: '95%', backgroundImage: elementBackground  }"
          ref="glView"
        >
        </web-gl-view>
        <div class="select-option">
          <div
            class="option"
            v-for="option in customizationOptions"
            :key="option.name"
          >
            <circle-select
              :option="option"
              :isSelected="selectedOption == option.name"
              @click.native="selectedOption = option.name"
            ></circle-select>
          </div>
        </div>
      </div>
      <div class="option-input">
        <keep-alive>
          <component :is="selectedOption"></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
  import WebGlView from "@/components/Pathfinder/WebGlView.vue";
  import WebGl from "@/components/Pathfinder/WebGlView/js/webgl";
  import ColorsSelect from "@/components/Pathfinder/Customization/ColorsSelect.vue";
  import PatternSelect from "@/components/Pathfinder/Customization/PatternSelect.vue";
  import LootSelect from "@/components/Pathfinder/Customization/LootSelect.vue";
  import NameSelect from "@/components/Pathfinder/Customization/NameSelect.vue";
  import CircleSelect from "@/components/CircleSelect.vue";
  import { mapState, mapActions, mapGetters } from "vuex";

  export default {
    data() {
      return {
        isLoading: false,
        customizationOptions: [
          {
            name: "ColorsSelect",
            fillImage: require("@/assets/icons/colors-select-icon.png")
          },
          {
            name: "PatternSelect",
            fillImage: require("@/assets/icons/pattern-select-icon.png"),
            fillColor: "#D94D43"
          },
          {
            name: "LootSelect",
            icon: require("@/assets/icons/loot-select-icon.svg"),
            fillColor: "#2C7BB8"
          },
          {
            name: "NameSelect",
            icon: require("@/assets/icons/name-select-icon.svg"),
            fillColor: "#7B2A90"
          }
        ],
        selectedOption: "ColorsSelect"
      };
    },
    components: {
      ColorsSelect,
      PatternSelect,
      LootSelect,
      NameSelect,
      CircleSelect,
      WebGlView
    },
    computed: {
      ...mapState({
        pathfinder: state => state.pathfinders.pathfinder,
        errors: state => state.errors
      }),
      ...mapGetters(["getElementBackground"]),
      elementBackground() {
        const background = this.getElementBackground(this.pathfinder);
        return background ? background : "";
      }
    },
    methods: {
      ...mapActions([
        "softUpdatePathfinder",
        "savePathfinderToDevice",
        "postPathfinder",
        "patchPathfinder"
      ]),
      navigateToLocation() {
        this.$router.push({ name: "location" });
      },
      done() {
        if (this.pathfinder.name !== "" && this.errors.length === 0) {
          this.isLoading = true;
          const avatar = this.$refs.glView.captureAvatar(256, 256);
          this.softUpdatePathfinder({ avatar });

          if (this.pathfinder.id) {
            this.patchPathfinder({
              params: { id: this.pathfinder.id },
              data: this.pathfinder
            }).then(_ => {
              this.isLoading = false;
              this.navigateToLocation();
            });
          } else {
            this.postPathfinder({ data: this.pathfinder }).then(response => {
              this.softUpdatePathfinder({ id: response.data.id });
              this.savePathfinderToDevice(this.pathfinder);

              this.isLoading = false;
              this.navigateToLocation();
            });
          }
        } else {
          this.$toast.open({
            duration: 3000,
            message: `Please add a valid name for your pathfinder!`,
            position: "is-bottom",
            type: "is-danger"
          });
          this.selectedOption = "NameSelect";
        }
      }
    },
    mounted() {
      if (WebGl.isWebGLAvailable() === false) {
        this.$toast.open({
          duration: 10000,
          message:
            "Your browser does not seem to support WebGl." +
            "Please upgrade your browser to the latest version, try a different browser, or use one of the devices provided.",
          position: "is-bottom",
          type: "is-danger"
        });
      }
    }
  };
</script>

<style lang="scss">
  @import "@/assets/global.scss";
  #customize {
    height: 100vh;
    position: relative;

    display: flex;
    flex-direction: column;

    .header {
      position: absolute;
      width: 100%;
      top: 0em;
      left: 0em;
      padding: 0.25em;

      .level-left {
        width: 30%;
      }

      .stacked {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 75%;
        }
        p {
          font-size: 0.6em;
          font-weight: bold;
          text-align: center;
        }
      }
    }

    .view {
      height: 100%;
      width: 100%;
      background: $background;

      .jungle-background {
        height: 55%;
        @include jungle-background;
        background-size: 100%;
      }

      .pathfinder-gl {
        background-size: 150%;
        background-position: center;
      }

      .select-option {
        height: 5%;
        position: relative;
        top: -2em;

        display: flex;
        flex-direction: row;
        justify-content: center;

        padding-left: 2em;
        padding-right: 2em;

        .option {
          padding-left: 1em;
          padding-right: 1em;
        }
      }

      .option-input {
        height: 45%;
        overflow: auto;
        padding-top: 0.5em;
      }
    }

    .level.is-mobile {
      flex-direction: row;
    }

    .level.no-margin {
      margin-bottom: 0em;
    }
  }
</style>
